$(function () {
	$.nette.ext('multiactionQuantityChange',{
		init: function() {
			var snippetsExt = this.ext('snippets', true);
			var ext = this;

			snippetsExt.after(function($el) {
				ext.init.call(ext, $el);
			});

			this.init($(document));
		}
	},{
		init: function ($el) {
			var $multiactionControls = $el.find('.js-multiaction-controls');

			$multiactionControls.each(function (i, el) {
				var $wrapperQuantityInput = $(el).find('input[name="quantity"]');
				var $wrapperAddButton = $(el).find('[name="addToBasket"]');

				$wrapperQuantityInput.on('change', function (e) {
					var triggerQuantityChange = e.target.value !== parseInt($(this).data('original-quantity'));

					if (triggerQuantityChange) {
						$wrapperAddButton.trigger('click');
					}
				})
			});
		}
	})
});
